<script setup lang="ts">
import BaseButtonSecondary from '../../base/BaseButtonSecondary.vue'
import { reactive, ref } from 'vue'
import { postBeneficialOwner } from '../../../utilities/api'
import { useLegalAccountDataState } from '../../../utilities/account/useAccountDataLegal'
import { notify } from '../../../utilities/useNotifications'
import { i18n } from '../../../localization'
import AddLegalManagerBeneficialOwnerForm from '../../wizard/ESAC/legal/form/LegalManagerBeneficialOwnerForm.vue'
import { LegalPerson } from '../../wizard/ESAC/legal/form/forms'
import { useLegalAccountFormState } from '../../../utilities/account/useAccountFormLegal'

const formValues = reactive(new LegalPerson())
const saving = ref(false)

async function addBeneficialOwner() {
    saving.value = true

    const { valid } = await useLegalAccountFormState().currentForm.validate()
    const state = useLegalAccountDataState()

    if (valid) {
        postBeneficialOwner(state.legalProfile.legal_profile_uid, formValues).then(() => {
            useLegalAccountFormState().currentForm.resetForm()
            notify('Success', i18n.global.t('legal_account_managers.manager_invited_notice'))
            state.fetchAccountData().then(() => {
                saving.value = false
            })
        })
    }
    saving.value = false
}
</script>

<template>
    <div>
        <AddLegalManagerBeneficialOwnerForm
            v-model="formValues"
            is-beneficial-owner></AddLegalManagerBeneficialOwnerForm>

        <div class="flex justify-end pt-4">
            <BaseButtonSecondary :disabled="saving" :loading="saving" @click="addBeneficialOwner()"
                >Add Beneficial Owner</BaseButtonSecondary
            >
        </div>
    </div>
</template>
